import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { AppRoutes } from '@/constants/routes';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { EventViewErrorReason } from '@/types/event';

interface EventViewErrorStateProps {
    reason: EventViewErrorReason;
    onRetry: () => void;
}

export function EventViewErrorState({
    reason,
    onRetry,
}: EventViewErrorStateProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const navigate = useNavigate();
    const isMissing = reason === EventViewErrorReason.NOT_FOUND;

    return (
        <div className="h-full flex flex-col items-center justify-center gap-6 px-4">
            <div className="text-center">
                <h1 className="text-xl font-bold text-white-100 mb-2">
                    {t(`page.errorState.${reason}.title`)}
                </h1>
                <p className="text-sm text-grey-100">
                    {t(`page.errorState.${reason}.message`)}
                </p>
            </div>
            {isMissing ? (
                <Button onClick={() => navigate(AppRoutes.HOME)}>
                    {t('common:notFound.goHome')}
                </Button>
            ) : (
                <Button onClick={onRetry}>{t('page.errorState.retry')}</Button>
            )}
        </div>
    );
}
